var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,400V0H800z",
    fill: "#0051ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,400H800V0z",
    fill: "#215b33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,400 800,0",
    stroke: "#fcd116",
    strokeWidth: 36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M0,-40V0H20z",
    transform: "rotate(18,0,-40)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s2",
    transform: "rotate(40.6)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "s1",
    xlinkHref: "#s",
    x: -104,
    transform: "rotate(-40.6,-104,0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s1",
    x: 208
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    transform: "scale(-1,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.c40fc3f74ac9736c3844f6b8120a249a.svg";
export { ForwardRef as ReactComponent };